import { retrieveFromWindow } from '../../utils'
import { INavConfig, INavLink } from './nav.interfaces'
import { NavLinkPaths } from './nav.enums'

export const navConfig: INavConfig = retrieveFromWindow('navConfig')

export const navBaseClass: string = 'nav'

export const navLinks: INavLink[] = [
  {
    name: 'Order',
    path: NavLinkPaths.ORDER,
    desktopPosition: 'left',
    mobileIcon: 'house'
  },
  {
    name: 'Order history',
    path: NavLinkPaths.ORDER_HISTORY,
    desktopPosition: 'left',
    mobileIcon: 'receipt'
  },
  {
    name: 'Help & support',
    path: NavLinkPaths.HELP_AND_SUPPORT,
    desktopPosition: 'left',
    mobileIcon: 'speech-help'
  },
  {
    name: 'Account details',
    path: NavLinkPaths.ACCOUNT_DETAILS,
    desktopPosition: 'right',
    mobileIcon: 'user'
  },
  {
    name: 'Log out',
    className: `${navBaseClass}__logout`,
    path: NavLinkPaths.LOG_OUT,
    desktopPosition: 'right',
    clickHandler: function () {
      sessionStorage.removeItem('shop_session')
    }
  }
]
